<template>
  <div class="general-settings">
    <h1>General settings</h1>
    <div class="enable-footer-wrap">
      <div class="top">
        <h2>Enable footer</h2>
        <a-switch :checked="isEnabled" @change="onChange" />
      </div>
      <div class="bottom">
        <p>Enable/disable footer on your website.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isEnabled: {
      type: Boolean,
    },
  },
  methods: {
    onChange(checked) {
      this.$emit("enableFooter", checked ? 1 : 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.general-settings {
  position: relative;
  h1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #001529;
    border-bottom: 1px solid #cbcbe4;
    padding: 25px 0;
  }
  .enable-footer-wrap {
    margin: 32px 0;
    max-width: 550px;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #001529;
        margin: 0 0 15px 0;
      }
    }
    .bottom {
      p {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #001529;
      }
    }
  }
}
</style>